// App wide constants

export const WHATSAPP_NUMBER = '+6285171136399'
export const WHATSAPP_LINK = 'https://wa.me/+6285171136399/'

export const EMAIL_CONFIG = {
  production: {
    noReply: 'PiBo (No Reply) <no-reply@bacapibo.com>',
    notification: 'PiBo Notification <halo@notification.bacapibo.com>',
    marketing: 'PiBo Marketing <halo@marketing.bacapibo.com>',
  },
  staging: {
    noReply: 'PiBo (No Reply) <no-reply@bacapibo.dev>',
    notification: 'PiBo Notification <halo@notification.bacapibo.dev>',
    marketing: 'PiBo Marketing <halo@marketing.bacapibo.dev>',
  },
  development: {
    noReply: 'PiBo (No Reply) <no-reply@bacapibo.dev>',
    notification: 'PiBo Notification <halo@notification.bacapibo.dev>',
    marketing: 'PiBo Marketing <halo@marketing.bacapibo.dev>',
  },
} as const

export const LEGAL_NAME = 'PT PiBo Media Anak'
export const OFFICIAL_ADDRESS = 'Wisma Surya Kemang, Lt. 2, Jl. Kemang Raya No. 33, Jakarta Selatan 12730'

export const GENERAL_SUPPORT_EMAIL = 'support@bacapibo.com'

export const PARTNER_SUPPORT_EMAIL = 'partner-support@bacapibo.com'
export const REPLY_TO_PARTNER_SUPPORT_EMAIL = 'PiBo Partner Support <partner-support@bacapibo.com>'

export const DEVELOPER_EMAIL = 'furqon@bacapibo.com'
export const REPLY_TO_DEVELOPER_EMAIL = 'Furqon <furqon@bacapibo.com>'

export const CODA_FORM = 'https://coda.io/form/Bantu-kami-tawarkan-solusi-yang-tepat_dS8EvFXkiT8'
export const CODA_FORM_CONTACT_US = 'https://coda.io/form/Kontak-Kami_dwVGZx-XgK_'

export const HELP_URL = 'https://help.bacapibo.com'
export const WEBINAR_URL = 'https://akademi.bacapibo.com'
export const CHILD_SIGN_IN_GUIDE_URL = 'https://help.bacapibo.com/baca-sebagai-pengguna-anak-152'
export const FULL_GUIDE_URL = 'https://help.bacapibo.com/coba-pibo-sebagai-anak-150'
export const LEARN_MORE_ABOUT_PREMIUM_SEATS_URL = 'https://help.bacapibo.com/kelola-kursi-murid-130'
export const STARTING_GUIDE_URL = 'https://help.bacapibo.com/panduan-memulai-9'

export const XENDIT_EXPIRY_INVOICE_IN_HR_ADD_ON = 1
export const XENDIT_EXPIRY_INVOICE_IN_HR_NEW = 24

export const CALENDLY_PIBO = 'https://calendly.com/halo-bacapibo/konsultasipibo'
